/** Types */
export const CONNECT_NON_PROFIT = "CONNECT_NON_PROFIT";
export const CONNECT_BANK_ACCOUNT = "CONNECT_BANK_ACCOUNT";
export const GET_MY_BANK = "GET_MY_BANK";
export const GET_MY_BANK_SUCCESS = "GET_MY_BANK_SUCCESS";

export const DELETE_CONNECT_STRIPE = "DELETE_CONNECT_STRIPE";
export const UPDATE_CONNECT_BANK = "UPDATE_CONNECT_BANK";
